module.exports = __webpack_public_path__ + "img/logo-color-tat.e280bf53.svg";